var React = require('react');

function Webflow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M571.141 156.113C571.141 156.113 508.709 351.946 503.622 368.112C501.772 351.484 455.988 0 455.988 0C349.622 0 292.739 75.7469 262.679 155.651C262.679 155.651 186.835 351.946 180.36 368.574C179.898 353.332 168.799 157.96 168.799 157.96C162.324 60.0433 72.6066 0.461856 0 0.461856L87.8679 533C199.321 532.538 259.441 457.253 290.889 377.349C290.889 377.349 357.946 204.147 360.721 196.296C361.183 203.685 408.817 533 408.817 533C520.733 533 580.853 462.334 613.225 385.201L770 0.461856C659.471 0.461856 601.201 75.747 571.141 156.113Z","fill":"#212b36"}));
}

Webflow.defaultProps = {"width":"770","height":"533","viewBox":"0 0 770 533","fill":"none"};

module.exports = Webflow;

Webflow.default = Webflow;
